// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh3 {\n  text-transform: uppercase;\n}\n.label {\n  text-transform: uppercase;\n  font-size: 120%;\n  color: var(--lingusta-green);\n}\n.action {\n  cursor: pointer;\n  font-size: 120%;\n}\n", ""]);
// Exports
module.exports = exports;
